<div class="furniture-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Furniture Requirements</h3>
      </div> -->

      <nz-form-item>
        <nz-form-label nzRequired>Furniture Details</nz-form-label>
        <nz-form-control>
          <textarea nz-input formControlName="furniture_details" rows="4" placeholder="Enter furniture details">
          </textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>